import styles from './uploadExpenseTicketModal.module.css'
import { useState } from "react"
import { useActions } from "./actions"
import { FieldType, FileField, FileType, Form, FormField, Modal, ModalId, useUIActions, Validatable } from '../../../../features/ui'
import { toList } from '../../../../utils/listUtils'
import { Expense, Ticket } from '../../state/types'
import { fileHelpers } from '../../../../features/files'

type Props = {
    expense?: Expense
    afterSubmit: (ticket: Ticket) => void
}

export const UploadExpenseTicketModal = (props: Props) => {
    const { expense, afterSubmit } = props
    
    const [ticketFile, setTicketFile] = useState<File>()
    const [ticketValidation, setTicketValidation] = useState<string>()

    const { expenseTicketFileName } = fileHelpers
    
    const { submitTicket } = useActions()
    const { closeModal } = useUIActions()

    const onChangeFile = (value?: File) => {
        setTicketValidation(undefined)
        setTicketFile(value)
    }

    const fields: FormField[] = [
        {
            name: 'expense',
            type: FieldType.TEXT,
            label: 'Gasto',
            render: () => <>{expense?.name}</>
        },
        {
            name: 'receiptFile',
            type: FieldType.FILE,
            label: 'Factura / Comprobante',
            hint: 'Formato: PDF, JPG, PNG',
            render: () => (
                <Validatable validations={toList(ticketValidation)} left className={styles.ticketValidation}>
                    <FileField
                        id="ticketUrl"
                        fileName={expenseTicketFileName()}
                        fileTypes={[FileType.PDF, FileType.JPEG, FileType.PNG]}
                        onChange={onChangeFile}
                    />
                </Validatable>
            )
        }
    ]
    
    const validate = (): boolean => {
        if (!ticketFile) {
            setTicketValidation('Debe subir la factura o comprobante')
            return false
        }
    
        return true
    }

    const onSubmit = async () => {
        if (validate()) {
            const savedTicket = await submitTicket(expense!.id, ticketFile!)
            afterSubmit(savedTicket)
            onChangeFile(undefined)
        }
    }

    const handleCancel = () => {
        closeModal(ModalId.UPLOAD_EXPENSE_TICKET)
        onChangeFile(undefined)
    }

    return (
        <Modal
            modalId={ModalId.UPLOAD_EXPENSE_TICKET}
            title="Subir Factura / Comprobante"
            widthSize="m"
            actions={[]}
        >
            <Form
                formId="upload-expense-ticket-form"
                fields={fields}
                createMode={false}
                updateLabel="Confirmar"
                onSubmit={onSubmit}
                onCancel={handleCancel}
            />
        </Modal>
    )
}
